import HTTPRequestHandler from "../../utils/HTTPRequestHandler";
const httpRequestHandler = new HTTPRequestHandler();
const user_id = localStorage.getItem("user_id");
const user_name = localStorage.getItem("username");
const user_suffix = `?user_id=${encodeURIComponent(
  user_id
)}&user_name=${encodeURIComponent(user_name)}`;
const BASE_URL = "provisioning/";

// Action types as constants
const ACTION_TYPES = {
  admins: {
    SUCCESS: "FETCH_ADMINS_DATA_SUCCESS",
    FAILURE: "FETCH_ADMINS_DATA_FAILURE",
  },
  sectoradmins: {
    SUCCESS: "FETCH_ADMINS_DATA_SUCCESS",
    FAILURE: "FETCH_ADMINS_DATA_FAILURE",
  },
  operators: {
    SUCCESS: "FETCH_OPERATORS_DATA_SUCCESS",
    FAILURE: "FETCH_OPERATORS_DATA_FAILURE",
  },
};

/**
 * Builds the appropriate URL based on user type
 * @param {string} userType - Type of user (admins, sectoradmins, operators)
 * @param {string} [id] - Optional user ID
 * @returns {string} Constructed URL
 */
const buildUrl = (userType, id = "") => {
  let url = `${BASE_URL}`;

  if (userType === "operators") {
    url += `${userType}/`;
  }
  else{
    url += 'admins/'
  }

  if (id) {
    // Always add trailing slash after id
    url += `${id}/`;
  }

  if (userType === "operators") {
    url += user_suffix;
  } else {
    url += `${user_suffix}&${userType}=true`;
  }

  return url;
};

// const buildUrl = (userType, id = "") => {
//   if (userType === "operators") {
//     return `${BASE_URL}${userType}/${id}${user_suffix}`;
//   } else {
//     return `${BASE_URL}admins/${id}${user_suffix}&${userType}=true`;
//   }
// };

/**
 * Handles API response and dispatches appropriate actions
 * @param {Function} dispatch - Redux dispatch function
 * @param {Object} response - API response
 * @param {string} userType - Type of user
 */
const handleSuccess = (dispatch, response, userType) => {
  dispatch({
    type: ACTION_TYPES[userType].SUCCESS,
    payload: response.data,
  });
};

/**
 * Handles API errors and dispatches appropriate actions
 * @param {Function} dispatch - Redux dispatch function
 * @param {Error} error - API error
 * @param {string} userType - Type of user
 */
const handleError = (dispatch, error, userType) => {
  dispatch({
    type: ACTION_TYPES[userType].FAILURE,
    error: error.message || "An error occurred",
  });
  console.error(`Error in ${userType} operation:`, error);
};

/**
 * Fetches user data based on type
 * @param {string} userType - Type of user (admins, sectoradmins, operators)
 */
export const fetchUsersData = (userType) => async (dispatch) => {
  try {
    const response = await httpRequestHandler.get(buildUrl(userType));
    handleSuccess(dispatch, response, userType);
  } catch (error) {
    handleError(dispatch, error, userType);
  }
};

/**
 * Adds a new user
 * @param {Object} newUser - User data to add
 * @param {Function} successCallback - Callback for successful operation
 * @param {Function} errorCallback - Callback for failed operation
 * @param {string} userType - Type of user
 */
export const addUser =
  (newUser, successCallback, errorCallback, userType = "admins") =>
  async (dispatch) => {
    try {
      const response = await httpRequestHandler.post(
        buildUrl(userType),
        newUser
      );

      if (successCallback) {
        successCallback(response.data);
      }

      handleSuccess(dispatch, response, userType);
    } catch (error) {
      if (errorCallback) {
        errorCallback(error);
      }

      if (error.response) {
        dispatch({ type: "SET_NET_ERROR", payload: false });
      } else {
        handleError(dispatch, error, userType);
      }
    }
  };


/**
 * Edits an existing user
 * @param {string} id - User ID
 * @param {Object} userData - Updated user data
 * @param {Function} successCallback - Callback for successful operation
 * @param {Function} errorCallback - Callback for failed operation
 * @param {string} userType - Type of user
 */
export const editUser =
  (id, userData, successCallback, errorCallback, userType = "admins") =>
  async (dispatch) => {
    try {
      const response = await httpRequestHandler.patch(
        buildUrl(userType, id),
        userData
      );

      if (successCallback) {
        successCallback(response.data);
      }

      handleSuccess(dispatch, response, userType);
    } catch (error) {
      if (errorCallback) {
        errorCallback(error);
      }

      if (error.response) {
        dispatch({ type: "SET_NET_ERROR", payload: false });
      } else {
        handleError(dispatch, error, userType);
      }
    }
  };


/**
 * Deletes a user
 * @param {string} id - User ID to delete
 * @param {Function} successCallback - Callback for successful operation
 * @param {Function} errorCallback - Callback for failed operation
 * @param {string} userType - Type of user
 */
  export const deleteUserIdData =
  (id, successCallback, errorCallback, userType = "admins") =>
  async (dispatch) => {
    try {
      const response = await httpRequestHandler.delete(buildUrl(userType, id));

      if (successCallback) {
        successCallback(response.data);
      }

      handleSuccess(dispatch, response, userType);
    } catch (error) {
      if (errorCallback) {
        errorCallback(error);
      }

      if (error.response) {
        dispatch({ type: "SET_NET_ERROR", payload: false });
      } else {
        handleError(dispatch, error, userType);
      }
    }
  };


/**
 * Toggles user login permission
 * @param {string} userID - User ID
 * @param {Function} successCallback - Callback for successful operation
 */
export const toggleUserLogin =
  (userID, successCallback) => async (dispatch) => {
    try {
      const response = await httpRequestHandler.patch(
        `loginallowed/${user_suffix}`,
        { id: userID }
      );

      if (successCallback) {
        successCallback(response.data);
      }
    } catch (error) {
      console.error("Error toggling user login:", error);
    }
  };

